export function applyConfigurationPatch(
  base: Record<string, string>,
  patch?: Record<string, string | null>
): Record<string, string> {
  return Object.fromEntries(
    Object.entries({ ...base, ...patch }).filter(
      (entry): entry is [string, string] => entry[1] !== null
    )
  );
}

export function withoutKeys(
  record: Record<string, string>,
  keys: readonly string[]
): Record<string, string> {
  return Object.fromEntries(
    Object.entries(record).filter(([key]) => !keys.includes(key))
  );
}

export function configurationPatch(
  before: Record<string, string>,
  after: Record<string, string>
): Record<string, string | null> {
  return Object.fromEntries([
    ...Object.entries(after).filter(([key, value]) => before[key] !== value),
    ...Object.keys(before)
      .filter((key) => !(key in after))
      .map((key) => [key, null]),
  ]);
}
